export class EmailUtils {
    public static extractEmails(emails: string | null | undefined, separators: string[] = [',', ';', ' ']): string[] {
        return (emails || '')
            .split(new RegExp(separators.join('|'), 'g'))
            .map(x => x.trim())
            .filter(x => x.length > 0);
    }

    public static concatEmails(emails: string[], separator?: string): string | null {
        if (!emails || emails.length === 0) return null;
        separator = separator ? separator : ', ';

        return emails.join(separator);
    }
}
